import React, { useState, useRef } from "react";
import { FieldArray, Form, Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import SalesReturnService from "../../../../Service/Invoice/SalesReturn.service";
import invoiceService from "../../../../Service/Invoice/invoice.service";
import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import customerService from "../../../../Service/Customer/customer.service";
import Steper from "../../../MUI_components/stepper";
import AsynchronousDropdown from "../../../MUI_components/AutoComplete/asynchronousAutoComplete";
import Print from "../Receipt/salesReturnBill/WithoutBill/WoDot";
import PosPrint from "../Receipt/salesReturnBill/WithoutBill/WoPos";
import itemMasterService from "../../../../Service/Item-master/itemMaster.service";
import { NumFormat } from "Components/MUI_components/currencyFormat";
import {
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import Selects from "Components/MUI_components/AutoComplete/selects";
import { SALES_RETURN_TYPE } from "Components/Constants/SalesReturnType";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";
import { useReactToPrint } from "react-to-print";
import { pageStyle } from "Components/Print/printPagesStyles";
import BasicDialog from "Components/MUI_components/Dialog-Box/basicDialog";
import Loading from "Components/MUI_components/loading";
import { currency } from "Components/MUI_components/currencyFormatterTag";

export default function ReturnWithoutBill(props) {
  const { setOpen, setSubmitted } = props;
  const dispatch = useDispatch();
  const stockLocations = useSelector((state) => state.location);
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);
  const location = localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION_NAME);
  const [disabledForSingle, setDisabledForSingle] = useState(false);
  const [returnData, setReturnData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [printType, setPrintType] = useState("pos");

  const initReturn = {
    customer: "",
    returnData: [],
    code: "",
    remarks: "",
    paidStatus: 0,
    itemMaster: null,
    quantity: "",
    totalAmount: "",
    locationCode: "",
    costPrice: "",
    retailPrice: "",
    wholesalePrice: "",
    invoiceAmount: 0,
    reference: "",
    batch: "",
  };

  const validation = yup.object({
    customer: yup.object().required("Customer is required"),
    returnData: yup.array().required(),
  });

  const [activeStep, setActiveStep] = React.useState(0);
  const [submitting, setSubmitting] = React.useState(false);
  const [stock, setStock] = useState(initReturn);
  const [openBillPrint, setOpenBillPrint] = useState(false);
  const [openPosPrint, setOpenPosPrint] = useState(false);
  const [returnValues, setReturnValues] = useState("");
  const computerReceiptPrintComponent = React.useRef(null);
  const billReceiptPrintComponent = React.useRef(null);

  const getSteps = ["Return without bill", "Returned items"];

  const handleCheckboxChange = async (e) => {
    const isChecked = e.target.checked;
    setStock((prev) => ({ ...prev, isChecked }));

    if (isChecked) {
      try {
        const response = await itemMasterService.posSearch("customers");
        if (response && response.length > 0) {
          const firstStockItem = response[1]; // Corrected to index 0 if you want the first item
          const selectedItemMaster = firstStockItem.itemMaster;
          setStock((prev) => ({
            ...prev,
            isChecked,
            itemMaster: selectedItemMaster,
            costPrice: selectedItemMaster.costPrice || "",
            retailPrice: selectedItemMaster.retailPrice || "",
            wholesalePrice: selectedItemMaster.wholesalePrice || "",
            invoiceAmount: selectedItemMaster.invoiceAmount || 0,
            reference: selectedItemMaster.reference || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setStock((prev) => ({
        ...prev,
        isChecked,
        itemMaster: null,
        costPrice: "",
        retailPrice: "",
        wholesalePrice: "",
        invoiceAmount: 0,
        reference: "",
      }));
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handlePrintPOS = useReactToPrint({
    content: () => billReceiptPrintComponent.current,
    onAfterPrint: () => {
      setOpenBillPrint(true);
      setOpen(false);
    },
    pageStyle: pageStyle.receipt,
  });

  const handlePrintDotMatrix = useReactToPrint({
    content: () => computerReceiptPrintComponent.current,
    onAfterPrint: (values) => {
      setOpenBillPrint(true);
      setOpen(false);
    },
    pageStyle: pageStyle.a4,
  });

  const printTypeRef = useRef("pos");
  const handlePrint = () => {
    if (printTypeRef.current === "dot") {
      handlePrintDotMatrix();
    } else {
      handlePrintPOS();
    }
  };

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      let totalAmount = values.returnData
        .map((data) => data.totalAmount)
        .reduce((totalAmount, i) => totalAmount + i, 0);
      const res = await SalesReturnService.create({
        ...values,
        totalAmount: totalAmount,
      });
      setReturnData(res.submittedData);
      handlePrint();
      setSubmitted && setSubmitted((prev) => !prev);
      dispatch(
        openSnackbar(true, "success", `Sales return added successfully`)
      );
      setOpen(false);
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
    setSubmitting(false);
  };

  return (
    <Grid container justify="center">
      <Grid item lg={12} sm={12} xs={12}>
        <Formik
          initialValues={initReturn}
          validationSchema={validation}
          onSubmit={async (values) => {
            let val = {
              ...values,
              totalAmount: initReturn.totalAmount,
              locationCode: defaultLocationSelected.location.code,
              customerCode: values.customer.code,
              returnType: SALES_RETURN_TYPE.SALES_RETURN_WITHOUT_BILL,
            };
            if (activeStep === getSteps.length - 1) {
              setOpenBillPrint(true);
              setReturnValues(val);
            } else handleNext();
          }}
        >
          {(props) => {
            const { isSubmitting ,setFieldValue} = props;
            return (
              <Form autoComplete="off">
                <Steper
                  getSteps={getSteps}
                  StepContent={getStepContent}
                  activeStep={activeStep}
                  values={props.values}
                  setFieldValue={props.setFieldValue}
                />
                <div className="flex space-between mb">
                  <Button
                    disabled={activeStep === 0 || props.isValid === false}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  <div style={{ display: "flex" }}>
                    <Button
                      disabled={
                        submitting ||
                        (!props.values.returnData.length &&
                          activeStep === getSteps.length - 1)
                          ? true
                          : false
                      }
                      startIcon={
                        submitting && (
                          <CircularProgress color="inherit" size={20} />
                        )
                      }
                      variant="contained"
                      type="submit"
                      color="secondary"
                    >
                      {activeStep === getSteps.length - 1 ? "Complete" : "Next"}
                    </Button>
                    <BasicDialog
                      title="Sales Return Without Bill"
                      open={openBillPrint}
                      onClose={(e) => setOpenBillPrint(false)}
                    >
                      <div className="flex">
                        <button
                          disabled={disabledForSingle}
                          type="submit"
                          className="btn-success button"
                          onClick={() => {
                            handleSubmit(returnValues);
                            printTypeRef.current = "pos";
                          }}
                        >
                          pos bill
                          <span>
                            {isSubmitting ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : (
                              "[ Enter ]"
                            )}
                          </span>
                        </button>
                        <button
                          type="submit"
                          disabled={disabledForSingle}
                          onClick={() => {
                            handleSubmit(returnValues);
                            printTypeRef.current = "dot";
                          }}
                          className="btn-success button"
                        >
                          Dot matrix bill
                          <span>
                            {isSubmitting ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                      <div className="flex-end">
                        <Button
                          color="secondary"
                          onClick={() => {
                            setOpenBillPrint(false);
                          }}
                        >
                          Close
                        </Button>
                      </div>
                    </BasicDialog>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </Grid>
    </Grid>
  );

  function getStepContent(step, values, setFieldValue) {
    switch (step) {
      case 0:
        return (
          <div className="flex mt">
            <div className="col-4">
              <FormControl
                control="asynchronousAutoComplete"
                label="Customer"
                name="customer"
                Service={customerService}
                getOptionLabel={(option) =>
                  option.firstName +
                  "-" +
                  option.secondName +
                  "-" +
                  option.phone1 +
                  "-" +
                  option.phone2 +
                  " - " +
                  option.customerAddresses.map(
                    (row) => row.phone1 + " - " + row.phone2
                  )
                }
              />
            </div>
            <div className="col-7">
              <FormControl label="Remarks" name="remark" control="input" />
            </div>
          </div>
        );
      case 1:
        return (
          <FieldArray name="returnData">
            {(returnDataProps) => (
              <>
             <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                  <div>
                    <Checkbox
                      checked={stock.isChecked || false}
                      onChange={handleCheckboxChange}
                      size="small"
                    />
                  </div>
                  <div className="col-4">
                    <AsynchronousDropdown
                      inputProps={{
                        label: "Item Master",
                        size: "small"
                      }}
                      disabled={stock.editIndex || stock.editIndex === 0}
                      withoutLocationFilter
                      name="itemMaster"
                      Service={itemMasterService.search}
                      value={stock.itemMaster}
                      onChange={(e, newValue) =>
                        newValue === null
                          ? setStock({
                              ...stock,
                              itemMaster: null,
                              costPrice: "",
                              retailPrice: "",
                              wholesalePrice: "",
                              reference:"",
                              invoiceAmount:0,
                            })
                          : setStock({
                              ...stock,
                              itemMaster: newValue,
                              costPrice: newValue.costPrice,
                              retailPrice: newValue.retailPrice,
                              wholesalePrice: newValue.wholesalePrice,
                            })
                      }
                      getOptionLabel={(option) =>
                        option.name + " - " + option.barcode
                      }
                    />
                  </div>
                  {/* <div className="col-5">
                    <Selects
                      disabled
                      label="Stock Location*"
                      options={stockLocations}
                      name="locationCode"
                      value={defaultLocationSelected.location.code}
                    />
                  </div> */}
                   <td colSpan={2} className="col-2">
                    <TextField
                      type="number"
                      size="small"
                      name="invoiceAmount"
                      value={stock.invoiceAmount}
                      fullWidth                  
                      variant="outlined" 
                       label="Invoice Amount"
                      // inputProps={{
                      //   placeholder: "Invoice Amount",
                      // }}
                      onChange={(event) => {
                        let { value } = event.target;
                        value = Math.max(0, Number(value));
                        setStock({
                          ...stock,
                          invoiceAmount: value,
                        });
                      }}
                    />
                  </td>
                    <div className="col-2">
                    <FormControl
                      fullWidth
                      label="Quantity"
                       size="small" 
                      control="number"
                      name="quantity"
                      
                    />
                  </div>
                  <td colSpan={1} className="col-3">
                    <TextField
                      value={stock.reference}
                      size="small"
                      control="input"
                      name="reference"
                      label="Reference"
                       fullWidth                  // ← ADD
    variant="outlined"
                      onChange={(e) =>
                        setStock({
                          ...stock,
                          reference: e.target.value,
                        })
                      }
                    />
                  </td>
                 
                


                </div>
                <div className="row">
                  {/* <td colSpan={1} className="col-4">
                    <FormControl
                      value={stock.reference}
                      size="small"
                      control="input"
                      name="reference"
                      label="Reference"
                      onChange={(e) =>
                        setStock({
                          ...stock,
                          reference: e.target.value,
                        })
                      }
                    />
                  </td>
                  <td colSpan={2} className="col-5">
                    <TextField
                      type="number"
                      size="small"
                      name="invoiceAmount"
                      value={stock.invoiceAmount}
                      variant="filled"
                      inputProps={{
                        placeholder: "Invoice Amount",
                      }}
                      onChange={(event) => {
                        let { value } = event.target;
                        value = Math.max(0, Number(value));
                        setStock({
                          ...stock,
                          invoiceAmount: value,
                        });
                      }}
                    />
                  </td>
                  <div className="col-2">
                    <FormControl
                      fullWidth
                      label="Quantity"
                      control="number"
                      name="quantity"
                    />
                  </div> */}
                </div>
                <div className="flex flex-end mb">
                  <Button
                    variant="contained"
                    type="button"
                    disabled={
                      !stock.itemMaster ||
                      !values.quantity ||
                      !stock.retailPrice
                    }
                    color="primary"
                    onClick={() => {
                      const qty = values.quantity ? values.quantity : 1;
                      returnDataProps.push({
                        itemMaster: stock.itemMaster,
                        itemCode: stock.itemMaster.code,
                        customerCode: values.customer.code,
                        locationCode: defaultLocationSelected.location.code,
                        quantity: qty,
                        costPrice: stock.costPrice,
                        retailPrice: stock.retailPrice,
                        totalAmount:
                          stock.invoiceAmount > 0
                            ? stock.invoiceAmount * qty
                            : stock.retailPrice * qty,
                        invoiceAmount: stock.invoiceAmount,
                        batch: values.batch,
                      reference: stock.reference, // Include the reference here
                      });
                      setStock(initReturn);
                      setFieldValue("quantity", "");
                    }}
                  >
                    Add
                  </Button>
                </div>
                <div className="flex mt mb">
                  <TableContainer>
                    <Table size="small" aria-label="spanning table">
                      <TableHead style={{ backgroundColor: "#cacaca50" }}>
                        <TableRow>
                          <TableCell align="center" colSpan={4}>
                            Details
                          </TableCell>
                          <TableCell align="right">
                            {COLUMNS_NAME.AMOUNT}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell width="5"></TableCell>
                          <TableCell>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                          <TableCell align="right">
                            {COLUMNS_NAME.QUANTITY}
                          </TableCell>
                          <TableCell align="right">
                            {COLUMNS_NAME.PRICE}
                          </TableCell>
                          <TableCell align="right">
                            {COLUMNS_NAME.TOTAL}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {values.returnData.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell width="5">
                              <Delete
                                color="secondary"
                                style={{
                                  fontSize: 18,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure want to delete this?"
                                    )
                                  )
                                    returnDataProps.remove(index);
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              {row.itemMaster["name"] + (row.reference ? ` - ${row.reference}` : '')}
                            </TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`returnData[${index}].quantity`}
                                // onChange={(event) =>
                                //   props.setFieldValue(
                                //     `returnData[${index}].quantity`,
                                //     parseFloat(event.target.value)
                                //   )
                                // }
                              />
                            </TableCell>
                            <TableCell align="right">
                              <FormControl
                                control="customInput"
                                name={`returnData[${index}].invoiceAmount`}
                                value={
                                  row.invoiceAmount > 0
                                    ? row.invoiceAmount
                                    : row.retailPrice
                                }
                                // onChange={(event) =>
                                //   props.setFieldValue(
                                //     `returnData[${index}].invoiceAmount`,
                                //     parseFloat(event.target.value)
                                //   )
                                // }
                              />
                            </TableCell>
                            <TableCell align="right">
                              {currency(
                                row.invoiceAmount > 0
                                  ? row.invoiceAmount * row.quantity
                                  : row.retailPrice * row.quantity
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                      <TableHead>
                        {values.returnData.length === 0 ? (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              No Data
                            </TableCell>
                          </TableRow>
                        ) : (
                          <>
                            <TableRow>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <strong>{COLUMNS_NAME.TOTAL}</strong>
                              </TableCell>
                              <TableCell align="right">
                                <strong>
                                  {currency(
                                    values.returnData
                                      .map((data) =>
                                        data.invoiceAmount > 0
                                          ? data.invoiceAmount * data.quantity
                                          : data.retailPrice * data.quantity
                                      )
                                      .reduce(
                                        (totalAmount, i) => totalAmount + i,
                                        0
                                      )
                                  )}
                                </strong>
                              </TableCell>
                            </TableRow>
                          </>
                        )}
                      </TableHead>
                    </Table>
                  </TableContainer>
                </div>
                <div style={{ display: "none" }}>
                  {returnData.code && (
                    <>
                      <Print
                        ref={computerReceiptPrintComponent}
                        returnData={returnData}
                      />
                    </>
                  )}
                  {returnData.code && (
                    <>
                      <PosPrint
                        ref={billReceiptPrintComponent}
                        returnData={returnData}
                      />
                    </>
                  )}
                </div>
              </>
            )}
          </FieldArray>
        );
      default:
        return null;
    }
  }
}
